import React from 'react';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { GAME_ADMIN_RESOURCES, GAME_ADMIN_SCOPES, PAGE_NAMES } from 'constant';

import zkChangeHistory from './submodules/list';

const ZkChangeHistoryDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={GAME_ADMIN_RESOURCES.zkRevertDashboard}
				actions={[GAME_ADMIN_SCOPES[GAME_ADMIN_RESOURCES.zkRevertDashboard].getZKChangeHistory]}
				configPageName={PAGE_NAMES.gameAdmin}
				path={`${path}/zkChangeHistory`}
				component={zkChangeHistory}
				exact
			/>
			<Redirect to={`${path}/zkChangeHistory`} />
		</Switch>
	);
};

export default ZkChangeHistoryDashboard;
